module.exports = __webpack_public_path__ + "media/index.68fe1095.mp4";